import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

export default ({ onClick, disabled, isLoading, ...props }) => (
    <div className="field" {...props}>
        <div className="control">
            <button
                className={classNames('button', 'is-link', {
                    'is-loading': isLoading,
                })}
                onClick={onClick}
                disabled={disabled}
            >
                <FormattedMessage id="contactForm.submit" />
            </button>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/ConferenctProgramForm/components/SubmitButton.js